import { useAccount } from 'wagmi'
import { useMemo } from 'react'
import useSWR from 'swr'
import { getLidoRewards } from '~/apis/lido'
import { formatEther } from 'viem'
import { formatFormAmount } from '~/utils/numbers'
import { useStEthBalance, useWstEthBalance } from '.'

export const useLidoUserData = () => {
  const { address: account } = useAccount()

  const { data: rewardsData } = useSWR(
    account ? ['lido-rewards', account] : null,
    () => getLidoRewards(account!),
    {
      refreshInterval: 60000,
    },
  )

  const stETHBalance = useStEthBalance()
  const wstETHBalance = useWstEthBalance()
  const isStETHBalanceZero = useMemo(() => {
    return !!stETHBalance?.isZero()
  }, [stETHBalance])
  const isWstETHBalanceZero = useMemo(() => {
    return !!wstETHBalance?.isZero()
  }, [wstETHBalance])

  const stETHBalanceFormatted = useMemo(() => {
    return formatFormAmount(stETHBalance?.toDecimalsFixed(), 8) || '~'
  }, [stETHBalance])
  const wstETHBalanceFormatted = useMemo(() => {
    return formatFormAmount(wstETHBalance?.toDecimalsFixed(), 8) || '~'
  }, [wstETHBalance])

  const rewardTotals = rewardsData?.totals

  const ethRewards = useMemo(() => {
    const rawEthRewards = rewardTotals?.ethRewards
    return formatFormAmount(formatEther(BigInt(rawEthRewards ?? '0')), 8)
  }, [rewardTotals?.ethRewards])

  const currencyRewards = useMemo(() => {
    const rawCurrencyRewards = rewardTotals?.currencyRewards
    if (!rawCurrencyRewards) return '~'
    return formatFormAmount(rawCurrencyRewards, 2)
  }, [rewardTotals?.currencyRewards])

  return {
    isStETHBalanceZero,
    isWstETHBalanceZero,
    stETHBalanceFormatted,
    wstETHBalanceFormatted,
    ethRewards,
    currencyRewards,
    isConnected: !!account,
  }
}
